import PropTypes from 'prop-types'
import React from 'react'
import SearchIcon from '@material-ui/icons/Search'
import { navigate } from 'gatsby'

const Input = ({ docInfo: { type }, searchValue, setSearchValue }) => {
  function handleSearchInputChange(e) {
    setSearchValue(e.target.value)
  }

  const handleSearchInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      navigate(`/search?type=${type}&q=${searchValue}`, {
        state: {
          type,
          query: searchValue,
        },
      })
    }
  }

  return (
    <div className="field">
      <p className="control has-icons-left">
        <input
          aria-label="Search"
          className="input is-small is-rounded"
          type="search"
          placeholder="搜索文档"
          value={searchValue}
          onChange={handleSearchInputChange}
          onKeyDown={handleSearchInputKeyDown}
        />
        <span className="icon is-left">
          <SearchIcon />
        </span>
      </p>
    </div>
  )
}

Input.propTypes = {
  docInfo: PropTypes.object.isRequired,
  searchValue: PropTypes.string.isRequired,
  setSearchValue: PropTypes.func.isRequired,
}

export default Input
